import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_INSTORE_SETTINGS_SUCCESS,
    UPDATE_INSTORE_SETTINGS_SUCCESS,
    RESET_INSTORE_SETTINGS,
    GET_ALL_RESTAURANT_MENUS
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";

export const loadInStoreSettings = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/in-store`;

        axios().get(url)
            .then(response => loadInStoreSettingsSuccess(response, dispatch))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadSettingsFailure')))
            .finally(() => {
                dispatch({ type: LOADING, payload: false });
            });
    }
}

const loadInStoreSettingsSuccess = (response, dispatch) => {
    if (response.status !== 204) {
        dispatch({ type: LOAD_INSTORE_SETTINGS_SUCCESS, payload: response.data });
    }
}

export const updateInStoreSettings = (restaurantId, state, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/in-store`;

        let stateCopy = { ...state };
        delete stateCopy.skipTableSelection; // this should be used at Phase Two
        delete stateCopy.useGeneralDeliveryPartnerSettings; // not needed for instore

        axios().post(url, stateCopy)
            .then(response => updateInStoreSettingsSuccess(response, dispatch, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')))
            .finally(dispatch({ type: LOADING, payload: false }))
    }
}

const updateInStoreSettingsSuccess = (response, dispatch, callback) => {
    UPDATE_INSTORE_SETTINGS_SUCCESS
    dispatch({ type: UPDATE_INSTORE_SETTINGS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
}

export const resetInStoreSettings = () => {
    return (dispatch) => {
        dispatch({ type: RESET_INSTORE_SETTINGS });
    }
};

export const getAllRestaurantMenus = (restaurantId) => {
    return (dispatch) => {

        const url = `/restaurant/${restaurantId}/menu-draft-base-info`;

        axios().get(url)
            .then(response => dispatch({ type: GET_ALL_RESTAURANT_MENUS, payload: response.data }))
            .catch(error => console.log(error))
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/InStoreActions.js